var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"demand_index\"\u003E\u003Cdemand-table :demands=\"demands\" :meta=\"meta\" @load-data=\"loadProducts\"\u003E\u003C\u002Fdemand-table\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;